import * as React from "react";
import capitalize from "lodash/capitalize";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import CounterDetails from "components/metrics/CounterDetails";
import GaugeDetails from "components/metrics/GaugeDetails";
import HistogramDetails from "components/metrics/HistogramDetails";
import MeterDetails from "components/metrics/MeterDetails";
import TimerDetails from "components/metrics/TimerDetails";
import { useNodeMetric } from "hooks/useMetrics";
const DetailsForType = ({ metric }) => {
  const { t } = useTranslation("system");
  switch (metric.type) {
    case "counter":
      return /* @__PURE__ */ React.createElement(CounterDetails, { metric });
    case "gauge":
      return /* @__PURE__ */ React.createElement(GaugeDetails, { metric });
    case "histogram":
      return /* @__PURE__ */ React.createElement(HistogramDetails, { metric });
    case "meter":
      return /* @__PURE__ */ React.createElement(MeterDetails, { metric });
    case "timer":
      return /* @__PURE__ */ React.createElement(TimerDetails, { metric });
    default:
      return /* @__PURE__ */ React.createElement("i", null, t("metric_details.invalid_type", { type: metric.type }));
  }
};
const StyledMetricDetail = styled.div`
  dl {
    > dt {
      float: left;
    }

    &.metric-timer > dd {
      margin-left: 145px;
    }

    &.metric-meter > dd {
      margin-left: 115px;
    }

    &.metric-gauge > dd {
      margin-left: 90px;
    }

    &.metric-counter > dd {
      margin-left: 90px;
    }

    &.metric-histogram > dd {
      margin-left: 145px;
    }
  }
`;
const MetricDetails = ({ nodeId, metric, metric: { full_name: metricName } }) => {
  var _a;
  const { data: nodeMetrics } = useNodeMetric(nodeId, metricName);
  const currentMetric = (_a = nodeMetrics == null ? void 0 : nodeMetrics[metricName]) != null ? _a : metric;
  const type = capitalize(currentMetric.type);
  return /* @__PURE__ */ React.createElement("div", { className: "metric" }, /* @__PURE__ */ React.createElement("h3", null, type), /* @__PURE__ */ React.createElement(StyledMetricDetail, null, /* @__PURE__ */ React.createElement(DetailsForType, { metric: currentMetric })));
};
export default MetricDetails;
